import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import WhoWeAre from "./components/WhoWeAre";
import WhatWeDo from "./components/WhatWeDo";
import DharaFoundation from "./components/DharaFoundation";
import OurCSR from "./components/OurCSR";
import AboutUs from "./components/Aboutus";
import Contact from "./components/Contact";
import ScrollToTop from "./components/ScrollToTop";
import DonatePage from "./components/DonatePage";

function HomePage() {
  return (
    <>
      <Hero />
      <DharaFoundation />
    </>
  );
}

function App() {
  return (
    <Router>
       <ScrollToTop /> 
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/our-csr" element={<OurCSR />} />
        <Route path="/contact" element={<Contact />} />
       <Route path="/donate" element={<DonatePage />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;